export default __webpack_public_path__ + "static/media/icon-target.2235c5a5.svg";